export function goToApp(phoneNumber) {
    //判断环境
    let u = navigator.userAgent
    let isAndroid = u.indexOf("Android") > -1 || u.indexOf("Linux") > -1; //android终端或者uc浏览器
    let isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端

    try {
        if (isAndroid) {
            window.jxyy.goToLogin()
        } else if (isiOS) {
            window.webkit.messageHandlers.goToLogin.postMessage(phoneNumber)
        }
    } catch (error) {
        console.log('err', error)
    }
}